<template>
  <div>
      <div class="bg">
          <img :src="require('../../assets/product/bg-product.png')">
      </div>
      <div class='banner ft14'>
          Eyo 产品系列 ———— 选材天然才能守护健康
      </div>
      <div class="list flex hcenter">
          <div class="row flex vcenter py4">
              <div class='flex flex-column vcenter hcenter productItem my2 ' @click="$router.push('/productDetail/warm')">
                  <img class=' pointer' :src="require('../../assets/product/产品1.png')">
                  <p class='ft08 pointer'>硅岩保温板</p>
              </div>
              <div class='flex flex-column vcenter hcenter productItem my2 ' @click="$router.push('/productDetail/partition')">
                  <img class=' pointer' :src="require('../../assets/product/产品2.png')">
                  <p class='ft08 pointer'>隔墙板</p>
              </div>
              <div class='flex flex-column vcenter hcenter productItem my2 ' @click='$router.push("/productDetail/decoration")'>
                  <img class=' pointer' :src="require('../../assets/product/产品3.png')">
                  <p class='ft08 pointer'>洁净装饰板</p>
              </div>
              <div class='flex flex-column vcenter hcenter productItem my2 ' @click='$router.push("/productDetail/mute")'>
                  <img class=' pointer' :src="require('../../assets/product/产品4.png')">
                  <p class='ft08 pointer'>吸音板</p>
              </div>
              <div class='flex flex-column vcenter hcenter productItem my2 ' @click='$router.push("/productDetail/floor")'>
                  <img class=' pointer' :src="require('../../assets/product/产品5.png')">
                  <p class='ft08 pointer'>地板</p>
              </div>
              <div class='flex flex-column vcenter hcenter productItem my4 ' @click='$router.push("/productDetail/carbon")'>
                  <img class=' pointer' :src="require('../../assets/product/产品6.png')">
                  <p class='ft08 pointer'>竹盐负碳板</p>
              </div>
          </div>
      </div>
      <div class="animate ">
          <p class="ft45 bold t-center">
              源自强大的硅基芯材
          </p>
          <p class="ft25 t-center">划时代的性能跃进</p>
          <p class="ft25 t-center">更安全的无机胶凝材料</p>
          <p class="ft25 t-center">取自天然</p>
          <p class="ft18 t-center"><el-button type='text' @click='showDialog(200)'>查看芯材</el-button></p>
          <div class="case" @mouseenter='depart=true' @mouseleave='depart=false'>
                <img class="top" :style="{width:depart?'300px':'700px',left:depart?'55px':'135px',top:depart?'-30px':'50px'}" :src="require('../../assets/product/top.png')">
                <img class="middle" :style="{width:depart?'300px':'700px',left:depart?'55px':'135px',top:depart?'5px':'52px'}" :src="require('../../assets/product/middle.png')">
                <img class="content" :style="{left:depart?'55px':'135px',top:depart?'-10px':'52px'}" :src="require('../../assets/product/content.png')">
                <img class="bottom" :style="{width:depart?'300px':'700px',left:depart?'55px':'135px',top:depart?'120px':'52px'}" :src="require('../../assets/product/bottom.png')">
                <div class="text pb1" :style="{opacity:depart?'1':'0'}">
                    <p class='t-right my0'>硅基芯材采用天然原料合成</p>
                    <p class='t-right my0 pr6'>性能卓越又环保健康。 </p>
                </div>
                <div class="pop flex hcenter" :style="{opacity:depart?'1':'0',top:depart?'330px':'0px'}">
                    <img :src="require('../../assets/product/原料泡泡-1.png')" >
                    <img :src="require('../../assets/product/原料泡泡-2.png')" >
                    <img :src="require('../../assets/product/原料泡泡-3.png')" >
                    <img :src="require('../../assets/product/原料泡泡-4.png')" >
                    <img :src="require('../../assets/product/原料泡泡-5.png')" >
                    <img :src="require('../../assets/product/原料泡泡-6.png')" >
                </div>
            </div>

      </div>
      <div class="introduce">
          <div class="row flex vcenter py2">
              <div class="introduceItem t-center">
                  <img :src="require('../../assets/product/introduce1.png')">
                  <p class="ft30 t-left">E1级环保</p>
                  <p class='info-color ft15 t-left my0'>甲醛释放量≤0.124mg/m³</p>
                  <p class='info-color ft15 t-left my1'>超国标E1 级</p>
                  <p class='t-left'><el-button type='text ft15' @click='showDialog(201)'>了解环保性能 ></el-button></p>
              </div>
              <div class="introduceItem t-center">
                  <img :src="require('../../assets/product/introduce2.png')">
                  <p class="ft30 t-left">A1级防火</p>
                  <p class='info-color ft15 t-left my0'>可耐1200℃的高温，耐火极限最高可达4小时，真正做到防火不燃</p>
                  <p class='info-color ft15 t-left my1'>，消防安全有保障</p>
                  <p class='t-left'><el-button type='text ft15' @click='showDialog(202)'>了解防火性能 ></el-button></p>
              </div>
          </div>
          <div class="row flex vcenter py2">
              <div class="introduceItem t-center">
                  <img :src="require('../../assets/product/introduce3.png')">
                  <p class="ft30 t-left">长效抗菌</p>
                  <p class='info-color ft15 t-left my0'>表面致密无孔，可抗多种废气、酸碱、碘酒和血污，能满足多种环境</p>
                  <p class='info-color ft15 t-left my1'>中的耐污抗菌要求</p>
                  <p class='t-left'><el-button type='text ft15' @click='showDialog(203)'>了解抗菌性能 ></el-button></p>
              </div>
              <div class="introduceItem t-center">
                  <img :src="require('../../assets/product/introduce4.png')">
                  <p class="ft30 t-left">超级耐水</p>
                  <p class='info-color ft15 t-left my0'>浸水后的强度反而升高，弹性模量≥1100MPa，超级坚韧 不变形</p>
                  <p class='info-color ft15 t-left my1'>吸水厚度膨胀率≤10%</p>
                  <p class='t-left'><el-button type='text ft15' @click='showDialog(204)'>了解防水性能 ></el-button></p>
              </div>
          </div>
      </div>
      <div class="report">
          <div class="row py6">
              <div class="ft23 mb4">
                  国家权威检测报告
              </div>
              <div>
                  <el-button type='text' class='ft15' @click='showDialog(206)'>硅基芯材防火检测报告 — NFTC国家防火建筑材料质量监督检验中心</el-button>
              </div>
              <div>
                  <el-button type='text' class='ft15' @click='showDialog(207)'>吸音板防火检测报告 — NFTC国家防火建筑材料质量监督检验中心</el-button>
              </div>
              <div>
                  <el-button type='text' class='ft15' @click='showDialog(208)'>洁净装饰板综合检测报告 — CNAS国家建筑工程质量监督检验中心</el-button>
              </div>
              <div>
                  <el-button type='text' class='ft15' @click='showDialog(209)'>硅岩保温板综合检测报告 — CNAS国家建筑工程质量监督检验中心</el-button>
              </div>
              <div>
                  <el-button type='text' class='ft15' @click='showDialog(210)'>硅岩保温板外墙保温系统检测报告 — CNAS国家建筑工程质量监督检验中心</el-button>
              </div>
              <div>
                  <el-button type='text' class='ft15' @click='showDialog(211)'>胶粘剂检测报告 — CNAS国家建筑工程质量监督检验中心</el-button>
              </div>
              <div>
                  <el-button type='text' class='ft15' @click='showDialog(212)'>锚栓检测报告 — CNAS国家建筑工程质量监督检验中心</el-button>
              </div>
              <div>
                  <el-button type='text' class='ft15' @click='showDialog(213)'>洁净装饰板环保检测报告 — CNAS国家建筑工程质量监督检验中心</el-button>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            depart:false
        }
    }
}
</script>

<style lang='scss' scoped>

    .bg{
        background-image: url("../../assets/product/bg.png");
        background-size: cover;
        background-position-y: 30%;
        width: 100%;
        height: calc(100vh - 391px);
        position: relative;
        img{
            width: 900px;
            position: absolute;
            bottom: 0;
            right: 200px;
        }
    }
    .banner{
        background: #FBFBFB 0% 0% no-repeat padding-box;
        border: 2px solid #F6F6F6;
        color:#D4D5DA;
        height: 35px;
        line-height: 35px;
        padding: 0 55vh;
    }
    .list{
        border-bottom:1px solid #DEDEDE;
        .row{
            width: 1000px;
            flex-wrap: wrap;
            .productItem{
                width: 200px;
                img{
                    width: 60px;
                    height: 60px;
                }
            }
        }
    }
    .animate{
        border-bottom:1px solid #DEDEDE;
        .case {
            *{
                transition: all 0.3s;
            }
            width:1000px;
            margin:0 auto;
            position: relative;
            height: 600px;
            .top,.middle,.content,.bottom{
                width: 700px;
                position: absolute;
                left: 135px;
            }
            .top{
                top: 50px;
                z-index: 4;
            }
            .middle{
                top: 52px;
                z-index: 3;
            }
            .content{
                top: 52px;
                z-index: 2;
            }
            .bottom{
                top: 52px;
                z-index: 1;
            }
            .text{
                margin-left:50%;
                width: 50%;
                border-bottom: 1px solid black;
                position: relative;
                top:220px;
                z-index: 6;
            }
            .pop{
                position: relative;
                img{
                    width: 160px;
                    position: relative;
                }
            }
           
        }
       



  
    }
    .introduce{
        border-bottom:1px solid #DEDEDE;
        .row{
            width: 1000px;
            flex-wrap: wrap;
            margin: 0 auto;
            .introduceItem{
                width: 450px;
                margin:5px 25px;
                img{
                    width: 130px;
                    height: 130px;
                }
            }
        }
    }
    .report{
        border-bottom:1px solid #DEDEDE;
        .row{
            width: 1000px;
            margin: 0 auto;
            div{
                margin-left:25px;
            }
        }
    }
</style>